import { Box, Grid } from "@mui/material";
import { EnhancedCheckboxRHF, EnhancedDropDownRHF, LabelPosition, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";

import { FC, useState } from "react";

interface ITaxExemptionsSetupFieldsPanel {
  employeeDataById: any;
}
export const TaxExemptionsSetupFieldsPanel: FC<
  ITaxExemptionsSetupFieldsPanel
> = ({ employeeDataById }) => {
  const [showWsibWcbExemptAs, setShowWsibWcbExemptAs] = useState(false)
  const onWsibWcbExemptSelectionCahngeHandler =(selected:any)=>{
    setShowWsibWcbExemptAs(selected)
  }
  return (
    <Box
      sx={{
        "& .MuiFormControlLabel-root": {
          marginBottom: "0!important",
          color: "rgba(0, 0, 0, 0.6)",
          fontSize: "0.875rem"
        },
        "& .MuiFormControlLabel-root .MuiTypography-root": {
          fontSize: "0.875rem"
        }
      }}
    >
      <EnhancedCheckboxRHF
        name="cppQppExempt"
        checked={false}
        testId="cpp"
        checkboxLabel="CPP (YTD/Max : 0.00/0.00)"
      />
      <EnhancedCheckboxRHF
        name="eiExempt"
        checked={false}
        testId="ei"
        checkboxLabel="E.I	(YTD/Max : 0.00/0.00)"
      />
      <EnhancedCheckboxRHF
        name="federalTaxExempt"
        checked={false}
        testId="federalTax"
        checkboxLabel="Federal Tax"
      />
      <EnhancedCheckboxRHF
        name="provisionalTaxExempt"
        checked={false}
        testId="provisionalTaxExempt"
        checkboxLabel="Provincial Tax"
      />
      <EnhancedCheckboxRHF
        name="ehtOntarioExempt"
        checked={false}
        testId="ehtOntario"
        checkboxLabel="EHT Ontario"
      />
      <EnhancedCheckboxRHF
        name="ehtBcExempt"
        checked={false}
        testId="ehtBritishColumbia"
        checkboxLabel="EHT British Columbia"
      />
      {employeeDataById &&
        employeeDataById.employeePayroll.provinceOfEmployment.shortCode &&
        employeeDataById.employeePayroll.provinceOfEmployment.shortCode ===
        "QC" && (<EnhancedCheckboxRHF
          name="qpipExempt"
          checked={false}
          testId="qpipExempt"
          checkboxLabel="QPIP	(Max. = 0.00)"
        />)}
      {employeeDataById &&
        employeeDataById.employeePayroll.provinceOfEmployment.shortCode &&
        employeeDataById.employeePayroll.provinceOfEmployment.shortCode ===
        "QC" && (<EnhancedCheckboxRHF
          name="csstExempt"
          checked={false}
          testId="csstExempt"
          checkboxLabel="CSST"
        />)}
        <Grid size={{xs:12, sm:12, md:12, lg:12, xl:12}} sx={{display:"flex", alignItems:"center", "& .dropDownWrapper":{marginBottom:"0!important"}}}>
        <Grid size={{xs:12, sm:12, md:4, lg:4, xl:4}}>
          <EnhancedCheckboxRHF
            name="wsibWcbExempt"
            checked={false}
            testId="wsibWcbExempt"
            checkboxLabel="WSIB/WCB"
            onSelectionChangeHandler={onWsibWcbExemptSelectionCahngeHandler}
          />
        </Grid>
        {showWsibWcbExemptAs && <Grid size={{xs:12, sm:12, md:8, lg:8, xl:8}} sx={{marginTop:"11px"}}>
          <EnhancedDropDownRHF
                    selectName="wsibWcbExemptAs"
                    testId={`wsibWcbExemptAs`}
                    items={[
                      {label:"Not a director",value:200},
                      {label:"Director",value:100}
                    ]}
                    selectedItem={200}
                  />
        </Grid>}
        </Grid>
    </Box>
  );
};
